import { BehaviorSubject } from 'rxjs';
export default (({ formDescriptor })=>{
    const formDescriptor$ = new BehaviorSubject(formDescriptor);
    return formDescriptor$;
});
